export default __webpack_public_path__ + "static/media/logo-halloween.28f6f040.png";